﻿import {UIButton} from "./Tools/Base/UIButton";
import {UISprite} from "./Tools/Base/UISprite";

export class CoinsBoosterButton extends UIButton {

    Awake() {
        super.Awake();
        this.onPlayerChanged = this.onPlayerChanged.bind(this);
        this.icon = this.addChild(new UISprite("x2"));
        this.counter = 0;
        this.on("pointertap", () => Core.UI.coinsBooster.Show());
        Core.Player.on("Changed", this.onPlayerChanged);
        this.updateButtonVisibility();
    }

    ForceCheck() {
        this.updateButtonVisibility();
    }

    onPlayerChanged() {
        this.counter++;
        if (this.counter > 20) {
            this.counter = 0;
            this.updateButtonVisibility();
        }
    }

    updateButtonVisibility() {
        let incomeTimerX2 = Core.Player.Timers.GetTimerById(Core.Player.Timers.incomeBoosterTimerId);
        let isX2IncomeActive = incomeTimerX2 && !incomeTimerX2.IsFinished;
        let incomeTimerX4 = Core.Player.Timers.GetTimerById(Core.Player.Timers.incomeX4BoosterTimerId);
        let isX4IncomeActive = incomeTimerX4 && !incomeTimerX4.IsFinished;

        let isX2TakenToday = Core.Time.DayUniqId == Core.Player.Timers.l2b;

        let x2Active = !isX2IncomeActive && !isX4IncomeActive;
        let x4Active = isX2IncomeActive && !isX4IncomeActive;

        this.SetActive((x2Active || x4Active) && Core.Player.PlanetsSave.collection.length > 5);
        this.icon.setImage(x4Active ? "x4" : "x2");
    }

    Update() {
        this.updateButtonVisibility();
    }

    fitLayout(rect) {
        this.position.copyFrom(rect);
        this.icon.scale.set(rect.width / this.icon.texture.width);
        this.icon.position.set(rect.width * 0.5, rect.height * 0.5);
    }
}

